import docReady from './global';
import NlcMap from './map';
import Tabs from './tabs';
import Walkthrough from './walkthrough';

docReady(function () {
  window.nlcMaps = {
    map: new NlcMap(),
    tabs: new Tabs(),
    walkthrough: new Walkthrough(),
  };
});
